import {
    collection,
    getDocs,
} from "firebase/firestore";

import { db }
    from "./firebase";

export async function getCourts() {

    const snapshot =
        await getDocs(
            collection(
                db,
                "csc_courts"
            )
        );

    return snapshot.docs.map(
        (doc) => ({
            id: doc.id,
            ...doc.data(),
        })
    );
}